<template>
    <div>
        <modal class="pay-wallet-detail" :display="modalStatus.payWalletDetail" @modalStatus="closeModal" >
            <h1>付款成功</h1>
            <div class="pay-wallet-detail-wrap">
                <div class="content">
                    <div class="list">
                        <span class="title">訂單編號</span>
                        <span class="info">：{{walletPaymentInfo.referenceSeq}}</span>
                    </div>
                    <div class="list">
                        <span class="title">付款方式</span>
                        <span class="info">：{{transPayWay(walletPaymentInfo.paymentType)}}</span>
                    </div>
                    <div class="list">
                        <span class="title">扣款項目</span>
                        <span class="info">：{{transSource(walletPaymentInfo.sourceType)}}</span>
                    </div>
                    <div class="list">
                        <span class="title">扣款金額</span>
                        <span class="info">：{{toCurrency(walletPaymentInfo.amount?walletPaymentInfo.amount:0)}}</span>
                    </div>
                    <div class="list">
                        <span class="title">金額幣別</span>
                        <span class="info">：{{walletPaymentInfo.currencyType}}</span>
                    </div>
                    
                    <div class="list">
                        <span class="title">建立時間</span>
                        <span class="info">：{{getExpiredFormatDate(walletPaymentInfo.createTime)}}</span>
                    </div>
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button confirm" @click="closeModal()">確認</button>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';

import { mapGetters } from 'vuex'
import { 
    apiGetVirtualAccount,
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
        }
    },
    props:{
        walletPaymentInfo: {},
    },
    // mounted() {
    //     this.$analytics.logEvent('新增委託_ATM付款', { screen_name: '新增委託_ATM付款'})

    // },
    watch:{
        taskId: function (val) {
            if(val){
                // this.getVirtualAccountDetail(val)
            }
            // this.getBillDetail(val)
        }
    },
    methods: {
        closeModal: function (type) {
            this.$router.push({ name: 'TaskManagementdefault'})
            this.$store.dispatch('setModalStatus', {state: false, type: 'payWalletDetail'})
        },
        getVirtualAccountDetail: function (taskId) {
            let data = taskId

            apiGetVirtualAccount(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.virtualAccountDetail = res.data.result.bindAccountDto
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        // transSource: function (value) {
        //     if( value == 'BOOKING_DEPOSIT' ){
        //         return '訂金'
        //     }else if( value == 'CONTRACT_DEPOSIT' ) {
        //         return '押金'
        //     }else if( value == 'CONTRACT_BILL' ) {
        //         return '帳單'
        //     }else if( value == 'HOUSE_TASK_BONUS' ) {
        //         return '委託獎金'
        //     }else if(value == 'HOUSE_LEDGER'){
        //         return '記帳'
        //     }else if(value == 'RETURN_PAID_HOUSE_TASK_BONUS'){
        //         return '委託退款'
        //     }else if(value == 'BOOKING_DEPOSIT_FOR_TENANT_REJECT'){
        //         return '取消預定'
        //     }
        // },
        // transPayWay: function (value) {
        //     if( value == 'WALLET' ){
        //         return '飛豬錢包'
        //     }else if( value == 'TRANSFER' ) {
        //         return '匯款轉帳'
        //     }else if( value == 'TASK_REFUND' ) {
        //         return '系統退款'
        //     }else if( value == 'DEPOSIT_FORFEIT' ) {
        //         return '訂金補償'
        //     }
        // },
        getExpiredFormatDate: function (time){
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            formatDate[5] = (Array(2).join(0)+date.getSeconds()).slice(-2);
            //月及天兩位數
            formatDate[6] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[7] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            // if(formatDate[3] - 8 < 0){
            //     formatDate[3] = 24+(formatDate[3]-8);
            //     formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            // }else{
            //     formatDate[3] = formatDate[3]-8;
            //     formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            // }
            return formatDate[0]+'/'+formatDate[6]+'/'+formatDate[7]+' '+formatDate[3]+':'+formatDate[4]+':'+formatDate[5];
        },
        // toCurrency: function (num){
        //     if(num){
        //         var parts = num.toString().split('.');
        //         // console.log(parts);
        //         parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //         return parts.join('.');
        //     }
        // },
    },
    computed: {
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
    }
}
</script>
<style lang="scss"  >
    #modal.pay-wallet-detail{
        .modal-content{
            width: 448px;
            padding: 0 !important;
            .detail{
                align-items: flex-start;
                >h1{
                    font-size: 24px;
                    margin: 32px auto 20px;
                }
                .pay-wallet-detail-wrap{
                    padding: 32px;
                    .content{
                        margin-bottom: 20px;
                        .list{
                            display: flex;
                            margin-bottom: 16px;
                            .title{
                                display: block;
                                width: 56px;
                            }
                        }
                        .warm{
                            color: #fc7171;
                        }
                    }
                }
            }
            
            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                margin: 0 auto;
                button{
                    width: 384px;
                    height: 44px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/modal/payWalletDetail.vue